<template>    
    <b-row :class="myStyleclass" class="main-row">

        <transition name="fade" mode="out-in">
            <router-view @changeColor="setBackgroundColor"></router-view>
        </transition>
    

        <b-row class="bc-color-timer timer-row">
            <b-col cols="4" align-self="center">
                <router-link :to="{name:'slide10',params:{lang:lang}}"><b-button size="md" variant="info"><h2><strong>{{ $t('slide9.text1') }}</strong></h2></b-button></router-link>                
            </b-col>
            <b-col cols="4">
                <app-timer :slide_redirect="redirect" timer_seconds="900" typeGame="game1" @sendTime="fCalculTime"></app-timer>
            </b-col>
            <b-col cols="4" align-self="center">   
                <b-button v-if="showSendAnswer" @click="fSendAnswer" size="md" variant="success"><h2><strong>{{ $t('slide9.text2') }}</strong></h2></b-button> 

                <b-modal v-model="modalSendAnswerNotShow" ok-only ok-variant="secondary" :title="$t('slide9.text3')" 
                effect="fade/zoom" :ok-title="$t('slide9.text5')">
                    <form role="form" method="post">
                        <div class="form-group"> 
                            <label><p>{{ $t('slide9.text4') }}</p></label>                                                       
                        </div>
                    </form>
                </b-modal>
                
                <b-modal v-model="modalSendAnswerYesShow" :title="$t('slide9.text3')" effect="fade/zoom" 
                :ok-title="$t('slide9.text7')" :cancel-title="$t('slide9.text8')" @ok="fSendAnswerYes">
                    <form role="form" method="post">
                        <div class="form-group">
                            <label><p>{{ $t('slide9.text6') }}</p></label>
                        </div>
                    </form>
                </b-modal>

            </b-col>
        </b-row>
        
    </b-row>         
</template>

<script>
import {mapState} from 'vuex';
import Timer from './Timer.vue';

import {bus} from '../main';

export default {    
    data(){
        return {
            modalSendAnswerNotShow: false,
            modalSendAnswerYesShow: false,
            myStyleclass: 'slide-body',

            elapsedTimeGame1: 0,
            lang:'',
            redirect:'',
        }
    },
    computed: {
        ...mapState(['showMenu','showSendAnswer','slide11Piece1random','slide11Piece2random','slide11Piece3random',
        'slide11Piece1','slide11Piece2','slide11Piece3', 'slide12Process1','slide12Process2','slide12Process3','slide13Machine1',
        'slide13Machine2','slide13Machine3','slide13Machine4','slide13Machine5','slide13Machine6','slide14Conditioners1',
        'slide14Conditioners2','slide14Conditioners3'])
    },
    components:{
        appTimer: Timer
    },
    methods:{
        setBackgroundColor(color){
            this.myStyleclass='slide-body '+color;
            
        },
        fCalculTime(result){
            this.elapsedTimeGame1 = result;
        },
        fSendAnswer(){        
            
            //Comprovar que totes les respostes estan completades
            if(this.slide14Conditioners1==null || this.slide14Conditioners2==null ){
                this.modalSendAnswerNotShow=true;
            }else if(this.slide11Piece1.trim()=="" || this.slide11Piece2.trim()=="" || this.slide11Piece3.trim()=="" || 
               this.slide12Process1.trim()=="" || this.slide12Process2.trim()=="" || this.slide12Process3.trim()=="" ||
               this.slide13Machine1.trim()=="" || this.slide13Machine2.trim()=="" || this.slide13Machine3.trim()=="" || 
               this.slide13Machine4.trim()=="" || this.slide13Machine5.trim()=="" || this.slide13Machine6.trim()=="" ||
               this.slide14Conditioners3.trim()==""){
               
                this.modalSendAnswerNotShow=true;

            }else{
                //Missatge: vols enviar la resposta?
                this.modalSendAnswerYesShow=true;
            }
        },
        fSendAnswerYes(){
            var PuntsJoc1=0;
            var valorReptes=10;
            var tempsRestant=0;
            var timerSeconds=900;           
            var solOptima=true;

            bus.$emit('getTime', true);            

            //Peces amagades
            if(this.slide11Piece1.trim()==this.slide11Piece1random[0].code)
            {
                PuntsJoc1 = PuntsJoc1 + valorReptes * 2;         
            }else{
                solOptima=false;
            }
            if(this.slide11Piece2.trim()==this.slide11Piece2random[0].code)
            {
                PuntsJoc1 = PuntsJoc1 + valorReptes * 2;          
            }else{
                solOptima=false;
            }
            if(this.slide11Piece3.trim()==this.slide11Piece3random[0].code)
            {
                PuntsJoc1 = PuntsJoc1 + valorReptes * 2;                     
            }else{
                solOptima=false;
            }
            
            //Diagrama de processos
            if(this.slide12Process1.trim()=="11")
            {
                PuntsJoc1 = PuntsJoc1 + valorReptes * 2;                               
            }else{
                solOptima=false;
            }
            if(this.slide12Process2.trim()=="18")
            {
                PuntsJoc1 = PuntsJoc1 + valorReptes * 2;                  
            }else{
                solOptima=false;
            }
            if(this.slide12Process3.trim()=="25")
            {
                PuntsJoc1 = PuntsJoc1 + valorReptes * 2; 
            }else{
                solOptima=false;
            }
            
            //Laberint
            if(this.slide13Machine1.trim()=="2")
            {
                PuntsJoc1 = PuntsJoc1 + valorReptes;                    
            }else{
                solOptima=false;
            }
            if(this.slide13Machine2.trim()=="12")
            {
                PuntsJoc1 = PuntsJoc1 + valorReptes;                  
            }else{
                solOptima=false;
            }
            if(this.slide13Machine3.trim()=="7")
            {
                PuntsJoc1 = PuntsJoc1 + valorReptes;                 
            }else{
                solOptima=false;
            }
            if(this.slide13Machine4.trim()=="21")
            {
                PuntsJoc1 = PuntsJoc1 + valorReptes;                  
            }else{
                solOptima=false;
            }
            if(this.slide13Machine5.trim()=="19")
            {
                PuntsJoc1 = PuntsJoc1 + valorReptes;                   
            }else{
                solOptima=false;
            }
            if(this.slide13Machine6.trim()=="14")
            {
                PuntsJoc1 = PuntsJoc1 + valorReptes;                  
            }else{
                solOptima=false;
            }

            //Condicionants
            if(this.slide14Conditioners1.trim()==true)
            {
                PuntsJoc1 = PuntsJoc1 + valorReptes * 2;                
            }else{
                solOptima=false;
            }
            if(this.slide14Conditioners2.trim()==true)
            {
                PuntsJoc1 = PuntsJoc1 + valorReptes * 2;
            }else{
                solOptima=false;
            }
            if(this.slide14Conditioners3.trim()=="0.3" || this.slide14Conditioners3.trim()=="0,3")
            {
                PuntsJoc1 = PuntsJoc1 + valorReptes * 2;                
            }else{
                solOptima=false;
            }
            
            tempsRestant = timerSeconds - this.elapsedTimeGame1;

            if(PuntsJoc1 > valorReptes*12){
                PuntsJoc1 = PuntsJoc1 + tempsRestant;
            }else{
                PuntsJoc1 = PuntsJoc1 + tempsRestant/5;
            }
            
            this.$store.dispatch('updateVariable',{name: 'PuntsJoc1',value: PuntsJoc1});
            this.$store.dispatch('updateVariable',{name: 'elapsedTimeGame1',value: this.elapsedTimeGame1});
            
            //Saltar a a diapositiva            
            this.$store.dispatch('updateVariable',{name: 'solOptima',value: solOptima});
            this.$router.push("/slide15/"+this.lang);            
        }
    },
    beforeCreate(){
        this.$store.dispatch('changeShowMenu',true);
        this.$store.dispatch('updateVariable',{name: 'showSendAnswer',value: true});
    },
    created(){
        this.lang=this.$route.params.lang;
        this.$i18n.locale=this.lang;
        this.redirect = '/slide15/'+this.lang;
    }     
}
</script>


<style scoped>

    .main-row{
        margin-left: 0px;
        margin-right: 0px;  
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }   

    .timer-row{
        width: 100%
    }

    .bc-color{
        background: #4e74e0;
    } 

    .bc-color-timer{
        background: #253789;
    }

    .bc-color-white{
        background: #ffffff;
    }
   
</style>